export default class BackProductStoreStatisticalList {

    StoreTime: Date;
    storeCount: number;
    UserName: string;
}